import { selectProfileName } from '../../accounts/selectors/profile-name.selector.ts';
import { PrepareScriptToSpeakProps } from '../../main/types/script-processing-types.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { DEFAULT_CHILD_NAME } from '../constants/child.ts';
import { ScriptReplacementKey } from '../slices/scripts/scripts.slice.types.ts';

import { selectAppState } from './app-state.selector.ts';
import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';
import { selectCurrentTaskStepViewCount } from './current-task-step-view-count.selector.ts';
import { selectReplacements } from './replacements.selector.ts';

export const selectPrepareScriptToSpeakProps = createMemoizedSelector(
  selectProfileName,
  selectAppState,
  selectCurrentLessonTaskStep,
  selectCurrentTaskStepViewCount,
  selectReplacements,
  (childName, appState, currentLessonTaskStep, taskStepViewCount, scriptReplacements): PrepareScriptToSpeakProps => {
    // Convert script replacements to Map and add childName
    const replacementsMap = new Map(Object.entries(scriptReplacements));
    replacementsMap.set(ScriptReplacementKey.ChildName, childName ?? DEFAULT_CHILD_NAME);

    return {
      lessonTaskStep: currentLessonTaskStep,
      taskStepViewCount,
      appState,
      scriptReplacements: replacementsMap,
    };
  }
);
